function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import InputField from '../inputField/InputField';
import { BORDER_TYPES_PROP_TYPES, BORDER_SIMPLE, STYLES_PROP_TYPES } from '../inputField/constants';
import CopyButtonWithTooltip from '../copyButton/CopyButtonWithTooltip';
import CopyChunkySvg from '../iconography/icons/CopyChunky';

var CopyField =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CopyField, _PureComponent);

  function CopyField() {
    _classCallCheck(this, CopyField);

    return _possibleConstructorReturn(this, _getPrototypeOf(CopyField).apply(this, arguments));
  }

  _createClass(CopyField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inputFieldId = _this$props.inputFieldId,
          inputFieldStyle = _this$props.inputFieldStyle,
          inputFieldBorderType = _this$props.inputFieldBorderType,
          label = _this$props.label,
          onCopyClick = _this$props.onCopyClick,
          tooltipArrowLocation = _this$props.tooltipArrowLocation,
          value = _this$props.value;
      var suffix = React.createElement(CopyButtonWithTooltip, {
        iconType: React.createElement(CopyChunkySvg, null),
        onCopyClick: onCopyClick,
        value: value,
        tooltipId: "".concat(inputFieldId, "-tooltip"),
        tooltipArrowLocation: tooltipArrowLocation
      });
      return React.createElement(InputField, {
        id: inputFieldId,
        label: label,
        readOnly: true,
        style: inputFieldStyle,
        borderType: inputFieldBorderType,
        value: value,
        suffix: suffix,
        hasMinAsideSpacing: true
      });
    }
  }]);

  return CopyField;
}(PureComponent);

_defineProperty(CopyField, "propTypes", {
  /**
  * The id of the input field
  */
  inputFieldId: PropTypes.string.isRequired,

  /**
  * The label to display on the input field
  */
  label: PropTypes.node.isRequired,

  /**
   * The text to display on the input field
   */
  value: PropTypes.string.isRequired,

  /**
   * Style of the input field
   */
  inputFieldStyle: STYLES_PROP_TYPES,

  /**
   * Style of the input field
   */
  inputFieldBorderType: BORDER_TYPES_PROP_TYPES,

  /**
   * Callback function called if the user clicks on the copy button
   */
  onCopyClick: PropTypes.func,

  /**
   * The direction that the tooltip should appear in relative to the icon
   */
  tooltipArrowLocation: PropTypes.string
});

_defineProperty(CopyField, "defaultProps", {
  inputFieldBorderType: BORDER_SIMPLE
});

export { CopyField as default };